<div class="page-header">
  <div class="header-row">
    <div></div><!-- spacer -->
    <div class="page-actions">
      <button class="btn btn-primary" (click)="openModal()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
        </svg>
        Send Notification
      </button>
    </div>
  </div>
</div>
<div class="notification-container">

  <!-- PAGE HEADER -->


  <!-- FILTERS SECTION (Company Listing Style) -->
  <div class="filters-section">
    <div class="filters-row">
      <!-- Filter Chips -->
      <div class="filter-chip" [class.active]="currentFilter === 'all'" (click)="setFilter('all')">
        All Notifications
        <span class="count">{{allCount }}</span>
      </div>
      <div class="filter-chip" [class.active]="currentFilter === 'customers'" (click)="setFilter('customers')">
        Customers
        <span class="count">{{ customerCount }}</span>
      </div>
      <div class="filter-chip" [class.active]="currentFilter === 'drivers'" (click)="setFilter('drivers')">
        Drivers
        <span class="count">{{ driverCount }}</span>
      </div>

      <!-- Right Side Actions -->
      <div class="filter-actions">
        <div class="search-box">
          <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
          <input type="text" class="search-input" placeholder="Search notifications..." [(ngModel)]="searchQuery"
            (ngModelChange)="onSearch($event)">
        </div>
        <svg *ngIf="cross" (click)="clearText()" class="cross-icon" width="16" height="16"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        <div class="menu-container">
          <button class="btn-menu" [class.active]="isMenuOpen" (click)="toggleMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
            </svg>
          </button>
          <div class="dropdown-menu" [class.show]="isMenuOpen">
            <a href="#" class="menu-item" (click)="clearAllNotifications(); $event.preventDefault()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
              Clear All
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NOTIFICATIONS LIST -->
  <div class="notifications-section">
    <div class="notifications-list">

      <!-- Skeleton Rows (shown while loading) -->
      <ng-container *ngIf="isLoading">
        <div *ngFor="let i of [1,2,3,4,5,6,7,8]" class="notification-item notification-skeleton">
          <div class="sk-icon"></div>
          <div class="sk-content">
            <div class="sk-line sk-line-title"></div>
            <div class="sk-line sk-line-body"></div>
          </div>
          <div class="sk-meta">
            <div class="sk-line sk-line-time"></div>
          </div>
        </div>
      </ng-container>

      <!-- Notification Item -->
      <ng-container *ngIf="!isLoading">
        <div *ngFor="let notification of filteredNotifications" class="notification-item" [class.read]="notification.read"
        [attr.data-type]="notification.type">
        <div class="notification-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
          </svg>
        </div>
        <div class="notification-content">
          <div class="notification-recipient">{{ notification.sent_to }}</div>
          <div class="notification-message"><strong>Message:</strong> {{ notification.message }}</div>
        </div>
        <div class="notification-meta">
          <div class="notification-time"> <a *ngIf="notification.image.length > 0" class="link" target="_blank"
              href="{{notification.image}}">
              <img src="{{notification.image}}" alt="Image"
                style="width: 50px; height: 50px; object-fit: cover; border-radius: 50%;">
            </a></div>
        </div>
        <div class="notification-meta">
          <div class="notification-time">{{ notification.sent_at | dateAgo}}</div>
          <button class="notification-delete" (click)="deleteOrder(notification.id)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

        <!-- Empty State -->
        <div *ngIf="filteredNotifications?.length === 0" class="empty-state">
          <div class="empty-state-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
            </svg>
          </div>
          <h3 class="empty-state-title">No Notifications Yet</h3>
          <p class="empty-state-subtitle">Notifications you send to customers and drivers will appear here.</p>
        </div>
      </ng-container>

    </div>
  </div>

  <!-- PAGINATION FOOTER -->
  <div class="pagination-footer">
    <button class="pagination-btn" (click)="previousPage()" [disabled]="currentPage === 1">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    </button>
    <div class="pagination-info">{{ getPaginationInfo() }}</div>
    <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage * itemsPerPage >= totalItems">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
      </svg>
    </button>
  </div>

  <!-- SEND NOTIFICATION MODAL -->
  <div *ngIf="isModalOpen" class="modal show" (click)="onBackdropClick($event)">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">
          <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
          </svg>
          Send Notification
        </h2>
        <button class="modal-close" (click)="closeModal()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg>
            Send To
            <span class="required">*</span>
          </label>
          <div class="recipient-type-toggle">
            <button class="toggle-option" [class.active]="recipientType === 'customers' || recipientType === 'all'"
              (click)="toggleRecipientType('customers')">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="toggle-icon">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
              Customers
            </button>
            <button class="toggle-option" [class.active]="recipientType === 'drivers'"
              (click)="toggleRecipientType('drivers')">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="toggle-icon">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
              </svg>
              Drivers
            </button>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
            </svg>
            Message
            <span class="required">*</span>
          </label>
          <textarea class="modal-textarea" placeholder="Enter your message here..." [maxlength]="maxChars"
            [(ngModel)]="messageText" (input)="updateCharCount()">
          </textarea>
          <div class="error-text" *ngIf="showError">
            Message is required
          </div>
          <div class="char-count" [ngClass]="getCharCountClass()">
            <span>{{ charCount }}</span> / {{ maxChars }}
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
            </svg>
            Attachments
            <span class="optional">(Optional)</span>
          </label>
          <input type="file" #fileInput class="file-input" multiple accept="image/*" (change)="onFileSelect($event)">
          <label for="fileInput" class="file-upload-btn" (click)="fileInput.click()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Files
          </label>
          <div class="file-preview-list">
            <div *ngFor="let preview of filePreviews; let i = index" class="file-preview-item">
              <img [src]="preview.url" [alt]="preview.file.name">
              <button class="file-preview-remove" (click)="removeFile(i)" type="button">×</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn-primary" (click)="sendNotification()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
          </svg>
          Send Notification
        </button>
      </div>
    </div>
  </div>

</div>